export const GET_USER_ROLES = 'userProfile/GET_USER_ROLES';
export const GET_USER_ROLES_SUCCESS = 'userProfile/GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_ERROR = 'userProfile/GET_USER_ROLES_ERROR';
export const SET_USER_FILTERS = 'userProfile/SET_USER_FILTERS';

export const SET_USER_ROLE = 'userProfile/SET_USER_ROLE';
//SET_USER_ROLE_ERROR

export const SET_USER_MERCHANT_DETAILS =
	'userProfile/SET_USER_MERCHANT_DETAILS';
